import api from "../../lib/api";

export default function Image({ src, alt, caption, preset = "article" }) {
  const fullSrc = api.getAssetUrl(src, { preset });

  const parts = [caption, alt].filter(Boolean);
  const displayCaption = parts.join(" / ");

  return (
    <div className="image h-fit flex flex-col items-center justify-center">
      <img src={fullSrc} alt={alt} srcSet="" className="max-h-[85vh]" />
      {displayCaption && (
        <div className="caption w-full h-fit overflow-y-hidden">{displayCaption}</div>
      )}
    </div>
  );
}
